
/**多语言配置说明 https://segmentfault.com/a/1190000014229902 */
//泰国

export const lang ={
  Please_set_materialtype_in_product_page:"โปรดไปที่หน้าผลิตภัณฑ์เพื่อแก้ไขและกำหนดประเภทวัสดุของผลิตภัณฑ์แต่ละรายการ - ผลิตภัณฑ์สำเร็จรูป - ผลิตภัณฑ์กึ่งสำเร็จรูป - อุปกรณ์เสริม",
deleteAccount:"ออกจากระบบ",
deleteAccountWillDeleteAllData:"การออกจากระบบบัญชีของคุณจะลบข้อมูลทั้งหมดและทำให้คุณไม่สามารถเข้าสู่ระบบได้",
backupDatabase:"ฐานข้อมูลสำรอง",
restoreDatabase:"กู้คืนฐานข้อมูล",
materialtype:"ประเภทวัสดุ",
Manufacturing:"รุ่นที่ผลิต",
Professional:"รุ่นมืออาชีพ",
Standard:"รุ่นมาตรฐาน",
product:"สินค้าสำเร็จรูป",
halfProduct:"ผลิตภัณฑ์กึ่งสำเร็จรูป",
components:"เครื่องประดับ",
Parent:"องค์ประกอบหลัก",
Children:"อุปกรณ์เสริมย่อย",
Level:"ลำดับชั้น",
Timing:"เวลา",
PieceCount:"ชิ้นงาน",
Wages:"ค่าจ้าง",
InternalProcess:"กระบวนการภายใน",
ExternalProcess:"กระบวนการภายนอก",
ProceName:"ชื่อกระบวนการ",
ProceIndex:"คำสั่งดำเนินการ",
ChargeMan:"อาจารย์ใหญ่",
BillMethod:"วิธีการเรียกเก็บเงิน",
ConsumTime:"ชั่วโมงทำงาน",
Accessories:"เครื่องประดับ",
Assembly:"ประกอบ",
materials:"วัสดุ",
task:"งาน",
process:"กระบวนการ",
BOM:"บอม",
Production:"การผลิต",
RestorePurchaseOneUse:"กู้คืนการซื้อ (ผู้ใช้หนึ่งราย (จำกัด เฉพาะการซื้อครั้งก่อน))",
buy_fail_try_again:"กรุณาคลิกอีกครั้งเพื่อซื้อ",
Export:"ส่งออก",
Date:"วันที่",
BankDetail:"รายละเอียดธนาคาร",
Seller:"ผู้ขาย",
Buver:"ผู้ซื้อ",
Currency:"สกุลเงิน",
CompanyName:"ชื่อ บริษัท",
ProformaInvoice:"ใบแจ้งหนี้ Proforma",
Discount:"การลดราคา",
PayStatus:"สถานะการชำระเงิน",
ShippingStatus:"สถานะการจัดส่ง",
FreightType:"ประเภทการขนส่ง",
Shipping:"ค่าขนส่ง",
Payment:"การชำระเงิน",
Moneyname:"ชื่อสกุลเงิน",
Tax:"ภาษี",
Freight:"ค่าใช้จ่ายในการขนส่งสินค้า",
Insurance:"ประกันภัย",
Bankfee:"ค่าธรรมเนียมธนาคาร",
Qc:"การรับรองคุณภาพ",
Exchangerate:"อัตราแลกเปลี่ยน",
Shippingnumber:"จำนวนการจัดส่ง",
ShipDate:"วันที่จัดส่ง",
Arrivedate:"วันที่มาถึง",
Grossweight:"น้ำหนักรวม",
CubicWeight:"น้ำหนักลูกบาศก์",
Totalpackages:"จำนวนแพ็คเกจทั้งหมด",
Moneytype:"ประเภทสกุลเงิน",
Quotedate:"วันที่เสนอราคา",
Validitydate:"วันที่ที่ถูกต้อง",
Paymentterm:"หมดอายุการจ่ายเงิน",
Priceterm:"ระยะการกำหนดราคา",
DeliveryTerm:"เวลาจัดส่ง",
BankName:"ชื่อธนาคาร",
BankAddress:"ที่อยู่ธนาคาร",
SwiftCode:"รหัสธนาคาร",
Review:"ทบทวน",
Signfor:"ลงชื่อรับ",
Finance:"การเงิน",
Receiver:"ผู้รับ",
Business:"ธุรกิจ",
ContactPerson:"ผู้ติดต่อ",
Profit:"กำไร",
Staff_must_use_in_browser_please_check_the_address_in_help_page:"พนักงานต้องใช้ Google Chrome โปรดตรวจสอบที่อยู่ IP ในหน้าช่วยเหลือของแอพคอมพิวเตอร์บริการหลักจากนั้นป้อนที่อยู่ในคอลัมน์ URL ของเบราว์เซอร์คอมพิวเตอร์อื่นเพื่อเปิดการเข้าสู่ระบบ",
newPassword:"รหัสผ่านใหม่",
ForgetPassword:"ลืมรหัสผ่าน",
ContactUs:"ติดต่อเรา/ให้คำแนะนำ",
Actualpay_should_big_then_shouldpay:"ใบเสร็จรับเงินที่เกิดขึ้นจริงต้องไม่มากกว่าลูกหนี้",
ShopAddress:"ที่อยู่ร้านค้าของฉัน สแกนรหัส QR เพื่อสั่งซื้อ",
Submit:"ส่ง",
All:"ทั้งหมด",
OrdernumExists:"หมายเลขคำสั่งซื้อมีอยู่แล้ว",
PermissionDenied:"การอนุญาตถูกปฏิเสธ",
StockTransfer:"โอนสต๊อก",
FromWarehouse:"โอนออกจากโกดัง",
ToWarehouse:"โอนเข้าโกดัง",
PleaseUseInWebBrowser:"โปรดใช้ฟังก์ชันส่งออก Excel ใน Google Chrome",
PleasePrintInWebBrowser:"กรุณาใช้ฟังก์ชั่นการพิมพ์ใน Google Chrome",
HistoryPrice:"ราคาประวัติศาสตร์",
SerialNumber:"หมายเลขซีเรียล",
Please_Use_In_APP:"กรุณาใช้ภายในซอฟต์แวร์คอมพิวเตอร์",
Please_Purchase_In_APP:"กรุณาซื้อภายในแอป ไม่ใช่ในเบราว์เซอร์",
Connect_Postgresql_database_Default_database_is_sqlite_in_local:"คุณสามารถเชื่อมต่อกับฐานข้อมูล Postgresql ได้ ข้อมูลของคุณจะถูกจัดเก็บไว้ในฐานข้อมูล Postgresql โดยค่าเริ่มต้น คุณไม่จำเป็นต้องเชื่อมต่อกับฐานข้อมูล Postgresql ค่าเริ่มต้นคือฐานข้อมูล Sqlite ในเครื่อง",
Connect_Postgresql_database_data_will_store_in_Postgresql:"เชื่อมต่อกับฐานข้อมูล Postgresql ข้อมูลของคุณจะถูกจัดเก็บไว้ในฐานข้อมูล Postgresql และข้อมูลจะถูกอ่านอีกครั้ง",
Use_sqlite_data_will_store_in_local:"เมื่อใช้ sqlite ข้อมูลจะถูกจัดเก็บไว้ในเครื่องท้องถิ่น",
UsePostgresqlDatabase:"การใช้ฐานข้อมูล PGSQL",
UseSqliteDatabase:"การใช้ฐานข้อมูล Sqlite",
DatabaseName:"ฐานข้อมูลชื่อ",
Test_connect:"ทดสอบการเชื่อมต่อ",
If_has_color_size_initstock_input_0_and_then_add_it_in_purchase:"หากสินค้ามีสีหรือขนาด กรุณากรอก 0 สำหรับสินค้าคงคลังเริ่มต้น หลังจากเพิ่มสินค้าแล้ว ให้กรอกสินค้าคงคลังในการซื้อ",
my:"ของฉัน",
my_shop_qrcode_scan:"รหัส QR ของร้านค้าของฉันช่วยให้ลูกค้าสามารถสแกนรหัสเพื่อสั่งซื้อได้ โทรศัพท์มือถือของลูกค้าจะต้องเชื่อมต่อกับเราเตอร์เดียวกันกับคอมพิวเตอร์ของคุณ",
ip:"ไอพี",
port:"ท่าเรือ",
orderstatus:"สถานะการสั่งซื้อ",
image:"รูปภาพ",
Template:"แม่แบบ",
Please_select_a_excel_file:"กรุณาเลือกไฟล์",
Please_select_only_one_excel_file:"สามารถเลือกได้เพียงไฟล์เดียวเท่านั้น",
Connect_Internet_Login_again:"เชื่อมต่ออินเทอร์เน็ตและเข้าสู่ระบบอีกครั้งก่อนที่จะซื้อ",

    productHasValidDate:'สินค้ามีระยะเวลาที่ถูกต้อง',
productHasColor:'สินค้ามีขนาดสี',
GeneralGoods:'สินค้าทั่วไป',
Selected:'เลือก',
RestorePurchase:'ทำการซื้อต่อ',
Buy_ElinkInvoice_Enterprise_Edition_OneUser:'ซื้อใบแจ้งหนี้ Enterprise Edition 1 ผู้ใช้อย่างถาวร',
Buy_ElinkInvoice_EnterpriseEdition_Unlimited_Users:'ซื้อ Invoicing Enterprise Edition นั้นไม่ จำกัด สำหรับผู้ใช้และอุปกรณ์',
Purchasing:'ซื้อ ... กรุณารอสักครู่ ...',
Validdate:'ช่วงเวลาที่มีผลบังคับใช้',
Makedate:'วันที่ผลิต',
Batch:'ชุด',
CheckVersion:'ตรวจสอบเวอร์ชั่น',
Please_set_this_ip_address_on_App:'โปรดตั้งค่าที่อยู่ IP นี้หรือที่อยู่ IP ของคอมพิวเตอร์ในแอป',
Open_this_link_on_other_Computer_and_Phone_connect_the_same_WiFi:'เปิดการเชื่อมต่อนี้ในคอมพิวเตอร์หรือเบราว์เซอร์มือถือของคุณ (เชื่อมต่อ WiFi เดียวกัน)',


    CheckVersion: 'ตรวจสอบเวอร์ชั่น',
You_need_to_purchase: 'คุณยังไม่ได้ซื้อกรุณาเพิ่ม WeChat ไปยัง Elink9988 E-mail: bvbuy@qq.com',
Thank_for_your_purchase: 'คุณซื้อไปแล้ว',
New_version_available: 'มีรุ่นใหม่',
Is_the_latest_version: 'เป็นรุ่นล่าสุด',
    please:'โปรด',
input:'อินพุต',
wrong:'ไม่ถูกต้อง',
Verifycode:'ตรวจสอบรหัส',
Upload:'อัปโหลด',
Download:'ดาวน์โหลด',
You_need_to_purchase_to_continue_use:'คุณต้องซื้อเพื่อใช้งานต่อไป',
CheckBuy:'ตรวจสอบการสั่งซื้อ',
Exists:'ที่มีอยู่',
NetworkUnavailable:'เครือข่ายไม่พร้อมใช้งาน',
Today:'ในวันนี้',
Yesterday:'เมื่อวาน',
ThisMonth:'เดือนนี้',
LastMonth:'เดือนที่แล้ว',
nickname:'ชื่อเล่น',
storeName:'ชื่อร้าน',
BuyStandAlone:'ซื้อรุ่นสแตนด์อะโลน',
PermissionDenied:'ปฏิเสธการอนุญาต',
Boss:'นาย',

    login:'เข้าสู่ระบบ',
operate:'ทำงาน',
register:'สมัครสมาชิก',
username:'ชื่อผู้ใช้',
password:'รหัสผ่าน',
User:'ผู้ใช้งาน',
ok:'ตกลง',
back:'กลับ',
success:'ความสำเร็จ',
fail:'ล้มเหลว',
cancel:'ยกเลิก',
add:'เพิ่ม',
edit:'แก้ไข',
delete:'ลบ',
refresh:'รีเฟรช',
close:'ปิด',
cancel:'ยกเลิก',
return:'กลับ',
ElinkInvoice:'ใบแจ้งหนี้ Elink',
Purchase:'ซื้อ',
BaseData:'ฐานข้อมูล',
Sell:'ขาย',
PurchaseReturns:'ซื้อคืน',
SellReturns:'ขายผลตอบแทน',
Inventory:'สินค้าคงคลัง',
Statistics:'สถิติ',
Receivable:'ลูกหนี้',
Payable:'ที่ต้องชำระ',
Orders:'สั่งซื้อ',
StockTransfer:'การโอนสต็อค',
StockRecall:'การเรียกคืนสินค้า',
Customer:'ลูกค้า',
Supplier:'ผู้ผลิต',
Warehouse:'คลังสินค้า',
Color:'สี',
Size:'ขนาด',
Category:'ประเภท',
Category2:'Category2',
Product:'สินค้า',
Account:'บัญชี',
AccountType:'ประเภทบัญชี',
Staff:'บุคลากร',
typeone:'ประเภท',
typetwo:'หมวดหมู่รอง',
ProductName:'ชื่อผลิตภัณฑ์',
Specification:'สเปค',
Barcode:'บาร์โค้ด',
Buyprice:'ซื้อราคา',
Sellprice:'ราคาขาย',
Wholesaleprice:'ราคาขายส่ง',
Currentstock:'กระแสสลับ',
Unit:'หน่วย',
Initstock:'หุ้นเริ่มต้น',
Parameter:'พารามิเตอร์',
Remark:'สังเกต',
Supplier:'ผู้ผลิต',
Customer:'ลูกค้า',
Staff:'บุคลากร',
Receivable:'ลูกหนี้',
payable:'ที่ต้องชำระ',
Receipts:'รายรับ',
Paid:'ต้องจ่าย',
Preferential:'พิเศษ',
DateDay:'วันที่',
OrderNum:'หมายเลขสั่งซื้อ',
Name:'ชื่อ',
UserName:'ชื่อผู้ใช้',
IdNum:'หมายเลขประจำตัว',
BirthDay:'วันเกิด',
SEX:'เพศ',
Female:'หญิง',
Male:'ชาย',
Select:'เลือก',
Address:'ที่อยู่',
Phone:'โทรศัพท์',
Email:'อีเมล์',
CardNum:'หมายเลขบัตร',
Price:'ราคา',
QTY:'จำนวน',
SupplierCategory:'หมวดหมู่ซัพพลายเออร์',
CustomerCategory:'หมวดหมู่ลูกค้า',
Power:'อำนาจ',
Role:'บทบาท',
save:'บันทึก',
image:'ภาพ',
search:'ค้นหา',
Year:'ปี',
Month:'เดือน',
Day:'วัน',
Total:'ทั้งหมด',
WorkReport:'รายงานการทำงาน',
Leave:'ออกจาก',
CheckIn:'เช็คอิน',
Announcement:'การประกาศ',
Approval:'การอนุมัติ',
Tracking:'การติดตาม',
Bill:'บิล',
OrdersDetail:'รายละเอียดการสั่งซื้อ',
Expense:'ค่าใช้จ่าย',
Income:'เงินได้',
Userfor:'Userfor',
Amount:'จำนวน',
Title:'หัวข้อ',
News:'ข่าว',
SelectFile:'เลือกไฟล์',
Content:'เนื้อหา',
Cost:'ราคา',
ApprovalUser:'ผู้ใช้ที่อนุมัติ',
ApprovalStatus:'สถานะการอนุมัติ',
ApprovalRemark:'หมายเหตุการอนุมัติ',
ApprovalDate:'วันที่อนุมัติ',
SubmitDate:'วันที่ส่ง',
Status:'สถานะ',
FromDateTime:'จากวันที่เวลา',
ToDateTime:'ถึงวันที่เวลา',
Subject:'เรื่อง',
Latitude:'ละติจูด',
Longitude:'ลองจิจูด',
Print:'พิมพ์',
DataTrans:'DataTrans',
OA:'โอเอ',
Setting:'การตั้งค่า',
Help:'ช่วยด้วย',
ScanOpenInPhone:'สแกนเปิดในโทรศัพท์',
Building:'อาคาร',
Room:'ห้อง',
HotelCheckIn:'เช็คอิน',
CheckOut:'เช็คเอาท์',
Hotel:'โรงแรม',
Checkintime:'เวลาเช็คอิน',
Checkouttime:'ตรวจสอบเวลา',
Deposit:'เงินฝาก',
Cost:'ราคา',
RoomNum:'จำนวนห้อง',
Rent:'ให้เช่า',
costday:'costday',
rent:'ให้เช่า',
waternum:'ระดับน้ำ',
electricnum:'ปริญญาไฟฟ้า',
gasnum:'ระดับแก๊ส',
watercost:'ค่าน้ำ',
electriccost:'ค่าไฟฟ้า',
gascost:'ต้นทุนก๊าซ',
cleaningcost:'ค่าใช้จ่ายในการทำความสะอาด',
networkcost:'ค่าใช้จ่ายเครือข่าย',
tvcost:'ค่าใช้จ่ายทีวี',
managecost:'จัดการค่าใช้จ่าย',
othercost:'ค่าใช้จ่ายอื่น ๆ',
totalcost:'ค่าใช้จ่ายทั้งหมด',
remark:'สังเกต',
addtime:'เพิ่มเวลา',
OpenInBrowser:'เปิดในเบราว์เซอร์',
InventoryProfit:'กำไรสินค้าคงคลัง',
InventoryLoss:'การสูญเสียสินค้าคงคลัง',
Buy:'ซื้อ',


Refresh:'รีเฟรช',
Add:'เพิ่ม',
Search:'ค้นหา',
Records:'รายการ',
}



// WEBPACK FOOTER //
// ./src/lang/th.js